import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["divider", "children", "color", "sameAsBefore", "spacing", "wrapper", "sx"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef } from 'react';
import { Box, DESKTOP, PRINT, BACKGROUND_COLORS } from "../../../index.js";
var CONTAINER_STYLES_DESKTOP_SX = {
  padding: 0,
  width: '94%',
  maxWidth: '1280px'
};
var CONTAINER_STYLES_SX = {
  marginRight: 'auto',
  marginLeft: 'auto',
  padding: '0 16px',
  fontFamily: 'body',
  color: 'black.400',
  fontSize: 'sm'
};
export var Container = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _objectSpread3;
  var _ref$divider = _ref.divider,
    divider = _ref$divider === void 0 ? false : _ref$divider,
    children = _ref.children,
    color = _ref.color,
    _ref$sameAsBefore = _ref.sameAsBefore,
    sameAsBefore = _ref$sameAsBefore === void 0 ? false : _ref$sameAsBefore,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? {
      base: '32px 0',
      md: '48px 0'
    } : _ref$spacing,
    _ref$wrapper = _ref.wrapper,
    wrapper = _ref$wrapper === void 0 ? {} : _ref$wrapper,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {
      PRINT: {},
      DESKTOP: {}
    } : _ref$sx,
    rest = _objectWithoutProperties(_ref, _excluded);
  var boxSx = {
    backgroundColor: color ? BACKGROUND_COLORS[color] : BACKGROUND_COLORS.white,
    marginTop: sameAsBefore ? {
      base: '-32px',
      md: '-48px'
    } : 0
  };
  var wrapperSxPrint = wrapper.sx ? wrapper.sx[PRINT] : {};
  return /*#__PURE__*/React.createElement(Box, _extends({
    padding: spacing
  }, wrapper, {
    sx: _objectSpread(_objectSpread(_objectSpread({}, boxSx), wrapper.sx), {}, _defineProperty({}, PRINT, _objectSpread({
      padding: '16px 0',
      margin: 0,
      backgroundColor: 'transparent'
    }, wrapperSxPrint)))
  }), /*#__PURE__*/React.createElement(Box, _extends({
    backgroundColor: "inherit"
  }, rest, {
    sx: _objectSpread(_objectSpread(_objectSpread({}, CONTAINER_STYLES_SX), sx), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, DESKTOP, _objectSpread(_objectSpread({}, CONTAINER_STYLES_DESKTOP_SX), sx[DESKTOP])), _defineProperty(_objectSpread3, PRINT, _objectSpread({
      maxWidth: 'none',
      width: '94%',
      backgroundColor: 'transparent'
    }, sx[PRINT])), _objectSpread3)),
    ref: ref
  }), children));
});